// body = document.querySelector("body#haro-clear-eye-vitamins-test");
body = document.querySelector("body[data-template-name='sifattemplate3']");
if (body) {
  fieldsets = body.querySelectorAll(".shopify_subscriptions_fieldset div");

  fieldsets.forEach(function(fieldset){
    fieldset.classList.add("added__by__sifat");
  });

  const blockWrappers = document.querySelectorAll(".shopify_subscriptions_app_block_label");

  const html = `
<ul class="radio__button" style="list-style: none; grid-column: span 2; border: none !important; padding: 0 !important; margin-top: 7px !important;">
  <li style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; background: #DFE8ED; padding: 10px; border-radius: 5px;">
    <div class="item-left" style="display: flex; align-items: center;">
      <img src="//harohealth.com/cdn/shop/files/ebook-icon.webp?v=1768064650&width=75"
           style="width: 35px; height: 35px; object-fit: cover; margin-right: 10px; border-radius: 4px;"
           alt="Healthy Eyes in the DIGITAL ERA">
      <span class="item-title" style="font-size: 11px; line-height: 1.2;">
        Healthy Eyes in the DIGITAL ERA
      </span>
    </div>
    <div class="item-right" style="text-align: right; min-width: 60px;">
      <strong style="display: block; color: #28a745; font-size: 11px;">$0.00</strong>
      <span style="text-decoration: line-through; font-size: 10px;">$60</span>
    </div>
  </li>

  <li style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; background: #DFE8ED; padding: 10px; border-radius: 5px;">
    <div class="item-left" style="display: flex; align-items: center;">
      <img src="//harohealth.com/cdn/shop/files/ebook-icon2.webp?v=1768064713&width=75"
           style="width: 35px; height: 35px; object-fit: cover; margin-right: 10px; border-radius: 4px;"
           alt="Nutrition for EYE HEALTH">
      <span class="item-title" style="font-size: 11px; line-height: 1.2;">
        Nutrition for EYE HEALTH
      </span>
    </div>
    <div class="item-right" style="text-align: right; min-width: 60px;">
      <strong style="display: block; color: #28a745; font-size: 11px;">$0.00</strong>
      <span style="text-decoration: line-through; font-size: 10px;">$60</span>
    </div>
  </li>
</ul>
`;

  blockWrappers.forEach(blockWrapper => {
    blockWrapper.insertAdjacentHTML("beforeend", html);
  });

  console.clear();
  console.log(fieldset);
}

// Hide Judge.me "Review for [product]" meta row on master PDP reviews.
(function () {
  var ROOT_SELECTOR = "#customer-reviews";

  function hideReviewForRows() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    var candidates = root.querySelectorAll("a[href*='/products/']");
    candidates.forEach(function (link) {
      var wrap =
        link.closest(".jdgm-rev__prod-info-wrapper") ||
        link.closest(".jdgm-rev__prod-info") ||
        link.closest(".jdgm-rev__product") ||
        link.closest(".jdgm-rev__item-product") ||
        link.closest(".jdgm-row-product") ||
        link.closest("div");

      if (!wrap) return;

      var text = (wrap.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      if (text.indexOf("review for") >= 0) {
        wrap.style.display = "none";
      }
    });
  }

  function boot() {
    hideReviewForRows();
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root || !window.MutationObserver) return;
    var obs = new MutationObserver(hideReviewForRows);
    obs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("judgeme:widgets_loaded", hideReviewForRows);
  document.addEventListener("judgeme:review:updated", hideReviewForRows);
})();
